import React, { useContext } from 'react';
import { SettingsContext } from "../Context";

function DefaultListItemImage(props) {

    const settings = useContext(SettingsContext);

    return (
        <div className="vehicleProductListComponent-imgWrapper">
            {settings.defaultThumbnailImageUrl && <img className="vehicleProductListComponent-imgWrapperImg img-fluid" src={settings.defaultThumbnailImageUrl} />}
        </div>);
}
export default DefaultListItemImage;